export const authTypes = {
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SET_AUTH: 'SET_AUTH',
  GET_PERMISSION: 'GET_PERMISSION',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  EXCHANGE_TOKEN: 'EXCHANGE_TOKEN',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
};

export type Permission =
  | 'WEB_ADMIN:AUTH'
  | 'EXEMPTION:R'
  | 'EXEMPTION:U'
  | 'EXEMPTION:D'
  | 'EXEMPTION_MED:R'
  | 'EXEMPTION_MED:U'
  | 'EXEMPTION_MED:D'
  | 'EXEMPTION_CIQR:R'
  | 'EXEMPTION_CIQR:U'
  | 'EXEMPTION_CIQR:D'
  | 'TRIP:R'
  | 'TRIP:U'
  | 'TRIP:D'
  | 'HEALTH:R'
  | 'HEALTH:U'
  | 'HEALTH:D'
  | 'ATTACHMENT:R'
  | 'ATTACHMENT:C'
  | 'USER:R'
  | 'USER:C'
  | 'USER:U'
  | 'USER:D'
  | 'ARTICLE:R'
  | 'ARTICLE:C'
  | 'ARTICLE:U'
  | 'ARTICLE:D'
  | 'TESTING:R'
  | 'TESTING:C'
  | 'TESTING:U'
  | 'TESTING:D'
  | 'REPORT:R'
  | 'FACILITY:C'
  | 'FACILITY:R'
  | 'FACILITY:U'
  | 'TIMESLOT:C'
  | 'TIMESLOT:R'
  | 'TIMESLOT:U'
  | 'FACILITY:C'
  | 'FACILITY:R'
  | 'FACILITY:U'
  | 'TIMESLOT:C'
  | 'TIMESLOT:R'
  | 'TIMESLOT:U'
  | 'FACILITY:C'
  | 'FACILITY:R'
  | 'FACILITY:U'
  | 'TIMESLOT:C'
  | 'TIMESLOT:R'
  | 'TIMESLOT:U'
  | 'VACCINATION:C'
  | 'VACCINATION:R';

export type IAuthState = Readonly<{
  isAuthenticated: boolean | null;
  user: { email: string; emailVerified: boolean; lastName: string; firstName: string } | null;
  permissions: Permission[];
}>;

export type SignInPayload = {
  username: string;
  password: string;
};

export type AuthPayload = {
  isAuthenticated: boolean;
  user: { email: string; emailVerified: boolean; lastName: string; firstName: string } | null;
};

export type PermissionPayload = {
  permissions: Permission[];
};

export type ExchangeTokenPayLoad = {
  idToken: string;
};

export type ChangePasswordPayload = {
  user: any;
  currentPassword: string;
  newPassword: string;
};
